module.exports = __webpack_public_path__ + "14four/static/media/bg.fcbc3d3f.jpg";